import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import permissionsSlice from './slices/permissionsSlice'
import userReducer from './slices/userSlice'
import shipmentsSlice from './slices/shipmentsSlice'
import sideNavReducer from './slices/sideNavSlice'
import tableReducer from './slices/tableSlice'
import validationsReducer from './slices/validationsSlice'
import recalculateBinReducer from './slices/recalculateBinSlice'
import floursReducer from './slices/floursSlice'
import dataAnalysisReducer from './slices/dataAnalysisSlice'
import insightsTabsReducer from './slices/insightsTabsSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    permissions: permissionsSlice,
    shipments: shipmentsSlice,
    user: userReducer,
    sideNav: sideNavReducer,
    table: tableReducer,
    validations: validationsReducer,
    recalculateBin: recalculateBinReducer,
    flours: floursReducer,
    dataAnalysis: dataAnalysisReducer,
    insightsTabs: insightsTabsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
